import React from 'react';
import PropTypes from 'prop-types';
import DefaultButton from '@components/buttons/default-btn/DefaultButton';

const ApplyButton = ({onClick, disabled}) => (
  <DefaultButton
    className="apply-button"
    locKey="qau-toolgroup-apply-btn"
    disabled={disabled}
    onClick={onClick}
  />
);

ApplyButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
}

export default ApplyButton;
